import { render, staticRenderFns } from "./baseSum.vue?vue&type=template&id=03471176&scoped=true&"
import script from "./baseSum.vue?vue&type=script&lang=js&"
export * from "./baseSum.vue?vue&type=script&lang=js&"
import style0 from "./baseSum.vue?vue&type=style&index=0&id=03471176&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03471176",
  null
  
)

export default component.exports